import React from 'react';
import CompanyInformationPresentational from './company-information-presentational';

const CompanyInformationFunctional = () => {
	return <CompanyInformationPresentational />;
};

export default CompanyInformationFunctional;
